import {
  Button,
  Heading,
  Stack,
  OrderedList,
  ListItem,
  Link,
  Text
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

function PreambleView() {
  return (
    <Stack spacing={6} py={4} px={4} flex="1 0 auto" minHeight="500px">
      <Heading size="md" lineHeight="1.5" maxWidth="90%">
        Let’s start by finding the type of finance that best suits you
      </Heading>
      <Stack spacing={8} maxWidth="90%">
        <OrderedList
          pl={8}
          spacing={8}
          style={{ listStyle: "none", counterReset: "cnt" }}
        >
          <ListItem
            style={{ counterIncrement: "cnt", position: "relative" }}
            _before={{
              content: "counter(cnt)",
              color: "#ffffff",
              fontWeight: "bold",
              background: "#163F6D",
              width: "32px",
              height: "32px",
              position: "absolute",
              left: "-44px",
              top: "4px",
              textAlign: "center",
              borderRadius: "50%",
              lineHeight: "31px",
              paddingTop: "1px"
            }}
          >
            Answer a few questions to find the type of finance that best suits
            your situation.
          </ListItem>
          <ListItem
            style={{ counterIncrement: "cnt", position: "relative" }}
            _before={{
              content: "counter(cnt)",
              color: "#ffffff",
              fontWeight: "bold",
              background: "#163F6D",
              width: "32px",
              height: "32px",
              position: "absolute",
              left: "-44px",
              top: "4px",
              textAlign: "center",
              borderRadius: "50%",
              lineHeight: "31px",
              paddingTop: "1px"
            }}
          >
            Then, with a few more details, we search the market to get your best
            deals.
          </ListItem>
        </OrderedList>
        <Text>
          It doesn’t take too long and your answers and information won’t be
          shared or affect your credit rating.
        </Text>
      </Stack>
      <Link as={RouterLink} to="/quick-details">
        <Button colorScheme="blue" size="lg" py={6} lineHeight={0}>
          Get started
        </Button>
      </Link>
    </Stack>
  );
}

export default PreambleView;
